class EncryptionDB {
    constructor() {
        this.dbName = 'EncryptionDB';
        this.storeName = 'keys';
        this.dbVersion = 1;
    }

    async openDB() {
        return new Promise((resolve, reject) => {
            const request = indexedDB.open(this.dbName, this.dbVersion);

            request.onupgradeneeded = (event) => {
                const db = event.target.result;
                if (!db.objectStoreNames.contains(this.storeName)) {
                    db.createObjectStore(this.storeName, { keyPath: 'id' });
                }
            };

            request.onsuccess = (event) => {
                resolve(event.target.result);
            };

            request.onerror = (event) => {
                reject(event.target.error);
            };
        });
    }

    async storeKeys(pkey, sharedKey, encryptedSharedKey) {
        const db = await this.openDB();
        const transaction = db.transaction([this.storeName], 'readwrite');
        const store = transaction.objectStore(this.storeName);

        const keyData = {
            id: 'encryptionKeys',
            pkey,
            sharedKey,
            encryptedSharedKey
        };

        store.put(keyData);

        return transaction.complete;
    }

    async getKeys() {
        const db = await this.openDB();
        const transaction = db.transaction([this.storeName], 'readonly');
        const store = transaction.objectStore(this.storeName);

        return new Promise((resolve, reject) => {
            const request = store.get('encryptionKeys');
            request.onsuccess = (event) => {
                resolve(event.target.result);
            };
            request.onerror = (event) => {
                reject(event.target.error);
            };
        });
    }

    async updateKey(keyName, newValue) {
        const db = await this.openDB();
        const transaction = db.transaction([this.storeName], 'readwrite');
        const store = transaction.objectStore(this.storeName);

        const request = store.get('encryptionKeys');

        request.onsuccess = (event) => {
            const keys = event.target.result || {};
            keys[keyName] = newValue;
            store.put(keys);
        };

        request.onerror = (event) => {
            console.error('Failed to retrieve keys from IndexedDB:', event.target.error);
        };
    }
}

export default EncryptionDB
